/**
 * The Joker mask: a face framed by eight belled points radiating from behind
 * it, alternating red and black.
 *
 * Symmetric about x = 100, which is both the look and the only way a shape this
 * busy stays drawable by hand — every lobe on the right is its left twin
 * mirrored, so the two sides cannot drift apart. The lobe geometry was computed
 * from eight angles rather than hand-written, then the face laid on top.
 *
 * Fixed colours, not theme tokens: this sits on the white face of a playing
 * card, and a joker that went pale in dark mode would stop looking like one.
 */
export function Joker({ className }: { className?: string }) {
  return (
    <svg
      className={`joker-fig${className ? ' ' + className : ''}`}
      viewBox="0 0 200 200"
      aria-hidden="true"
      focusable="false"
    >
      {/* ---- the eight points, behind the mask ---- */}
      <g className="jk-points">
        <path className="jk-black" d="M100.0 70.0Q123.7 49.5 144.9 22.0Q139.4 60.5 117.6 75.7Z" />
        <path className="jk-red" d="M82.4 75.7Q60.6 60.5 55.1 22.0Q76.3 49.5 100.0 70.0Z" />
        <path className="jk-black" d="M125.4 84.1Q148.7 81.7 180.8 77.1Q151.6 93.3 129.7 95.8Z" />
        <path className="jk-red" d="M70.3 95.8Q48.4 93.3 19.2 77.1Q51.3 81.7 74.6 84.1Z" />
        <path className="jk-black" d="M129.1 107.3Q150.7 112.1 178.0 131.2Q146.6 123.3 123.6 118.5Z" />
        <path className="jk-red" d="M76.4 118.5Q53.4 123.3 22.0 131.2Q49.3 112.1 70.9 107.3Z" />
        <path className="jk-black" d="M117.2 124.6Q127.4 139.8 135.6 169.4Q118.5 144.7 106.7 129.2Z" />
        <path className="jk-red" d="M93.3 129.2Q81.5 144.7 64.4 169.4Q72.6 139.8 82.8 124.6Z" />

        <circle className="jk-bell" cx="147.6" cy="17.2" r="5.5" />
        <circle className="jk-bell" cx="52.4" cy="17.2" r="5.5" />
        <circle className="jk-bell" cx="186.1" cy="75.6" r="5.5" />
        <circle className="jk-bell" cx="13.9" cy="75.6" r="5.5" />
        <circle className="jk-bell" cx="183.1" cy="133.2" r="5.5" />
        <circle className="jk-bell" cx="16.9" cy="133.2" r="5.5" />
        <circle className="jk-bell" cx="138.1" cy="174.3" r="5.5" />
        <circle className="jk-bell" cx="61.9" cy="174.3" r="5.5" />
      </g>

      {/* ---- the mask ---- */}
      <g className="jk-mask">
        <path
          className="jk-skin"
          d="M100 62c19 0 33 12 33 30 0 13-3 24-9 33-6 9-14 14-24 14s-18-5-24-14c-6-9-9-20-9-33 0-18 14-30 33-30Z"
        />

        <path className="jk-line" d="M79 85c4-4 11-4 15 1M121 85c-4-4-11-4-15 1" />
        <path className="jk-eye" d="M78 95c4-5 11-5 15 0-4 5-11 5-15 0Z" />
        <path className="jk-eye" d="M122 95c-4-5-11-5-15 0 4 5 11 5 15 0Z" />
        <circle className="jk-pupil" cx="85.5" cy="95" r="2.6" />
        <circle className="jk-pupil" cx="114.5" cy="95" r="2.6" />

        <path className="jk-line" d="M100 98v10c0 2-2 3-4 3" />
        <circle className="jk-blush" cx="76" cy="110" r="6" />
        <circle className="jk-blush" cx="124" cy="110" r="6" />
        <path className="jk-grin" d="M83 116c5 9 29 9 34 0-3 12-13 18-17 18s-14-6-17-18Z" />
      </g>
    </svg>
  )
}
